import React from 'react'

class PageTemplates extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.closeSearchTemplate = this.closeSearchTemplate.bind(this)
  }

  closeSearchTemplate () {
    document.querySelector('#id-search-page-fragment').remove()
  }

  SearchTemplate () {
  }

  componentDidMount () {}

  render () {
    // {/* SEARCH TEMPLATE - JUNE 13, 2022 */}
    if (this.props.search_template) {
      return (
        <section id="id-search-page-template" className="search-page-template">
          <section id="id-search-panel-page-navigation-container" className="modes-navigation-container">
            <span id="id-modes-navigation-close-trigger"
                  className="fa fa-times fa-2x modes-navigation-close-trigger-right"
                  onClick={this.closeSearchTemplate}></span>
            <span className="modes-navigation-title">
                            <span className="fa fa-search fa-lg modes-navigation-icon"></span>
                            Search
                        </span>
          </section>
          <section className="modes-body-container">
            {/* This is where the search items will appear. */}
            <section id="id-napps-search" className="modes-show modes modes-black">
              <section className="modes-inner-cover modes-inner-cover-full modes-white">
                <form action="post" id="id-napps-search-form" className="napps-search-form flex-y">
                  <div id="id-napps-search-form-input-container" className="self-align-center pad-y-3 w-safe-12">
                    <input type="search" name="app_name" id="id-napps-search-form-input"
                           className="w-100 h-px-8 self-align-center radius-sm pad-x-3"
                           placeholder="Search Latest and Existing Apps..."/>
                  </div>
                </form>
                Locate the search bar.
                {/* {this.props.children} */}
              </section>
            </section>
          </section>
        </section>
      )
    } else if (this.props.apps_latest_template) {}
    return null
  }
}

// new PageTemplates().searchTemplate();

export default PageTemplates